"use client";

import { ArrowRight, Droplets, HeartHandshake, Recycle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicAdvantages() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const values = [{
    icon: Recycle,
    title: "BUSINESS-FOCUSED APPROACH",
    body: "We look beyond the technical task to understand the wider process, reporting requirement, and business objective behind every project."
  }, {
    icon: HeartHandshake,
    title: "TAILORED SOLUTIONS",
    body: "Every solution is designed around the client’s systems, processes, and working methods—not a one-size-fits-all template."
  }, {
    icon: Droplets,
    title: "SECURE & SCALABLE",
    body: "We build reliable solutions with accuracy, confidentiality, flexibility, and future growth in mind."
  }];
  return <section data-section-id="1506" id="strategic-advantages" className="relative border-y border-border text-foreground py-28 overflow-hidden dark bg-accent !border-none border-1 border-[rgb(34,47,68)] md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -left-32 w-[28rem] h-[28rem] rounded-lg blur-3xl opacity-30" style={{
      background: "radial-gradient(circle, var(--secondary) 0%, transparent 65%)"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 right-0 w-[26rem] h-[26rem] rounded-lg blur-3xl opacity-25" style={{
      background: "radial-gradient(circle, var(--primary) 0%, transparent 70%)"
    }} />

      <div className="relative mx-auto max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={leftRef} className={`lg:col-span-8 flex flex-col gap-14 lg:gap-16 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            {}
            <div className="flex flex-col gap-6">
              <p className="font-mono text-xs md:text-[0.8125rem] uppercase tracking-[0.18em] text-muted-foreground" style={{
              letterSpacing: "0.18em"
            }}>WHY INFINIX SOLUTIONS</p>
              <h2 className="font-serif font-default text-foreground leading-[1.04] tracking-tight" style={{
              fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
              fontWeight: 600
            }}>Practical <span className="relative inline-block italic text-secondary" data-ast-id="f:/src/pages/Home/sections/StrategicAdvantages.tsx|sig:dwluhw" data-ast-start="2779" data-ast-end="3554" style={{
                fontWeight: '600'
              }} contenteditable="false">solutions,<svg aria-hidden="true" viewBox="0 0 220 14" className="absolute left-0 -bottom-2 w-full h-3" preserveAspectRatio="none" data-ast-id="f:/src/pages/Home/sections/StrategicAdvantages.tsx|sig:wbejb2" data-ast-start="3053" data-ast-end="3547"><path d="M3 9 Q 35 2, 70 7 T 140 6 T 215 8" fill="none" stroke="var(--secondary)" stroke-width="2.5" stroke-linecap="round" data-ast-id="f:/src/pages/Home/sections/StrategicAdvantages.tsx|sig:9bjkj7" data-ast-start="3292" data-ast-end="3541"></path></svg></span>&nbsp;<br />built around your business.</h2>
            </div>

            {}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {values.map((value, i) => {
              const Icon = value.icon;
              return <div data-index={i} key={value.title} className="group relative bg-card rounded-lg p-7 border border-border transition-all duration-300 ease-out hover:-translate-y-1 shadow-md">
                    <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg mb-5" style={{
                  backgroundColor: "var(--accent)"
                }}>
                      <Icon className="size-7 text-secondary" strokeWidth={1.5} />
                    </div>
                    <h3 className="font-serif font-default text-foreground mb-3 !w-[250px] !text-xl" style={{
                  fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)",
                  fontWeight: 600,
                  lineHeight: 1.15
                }}>
                      {value.title}
                    </h3>
                    <p className="text-sm md:text-[0.9375rem] leading-[1.65] text-muted-foreground">
                      {value.body}
                    </p>
                  </div>;
            })}
            </div>

            {}
            <div>
              <Button asChild variant="link" className="px-0 h-auto text-foreground hover:text-secondary">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-4 order-first lg:order-last w-1/2 lg:w-full mx-auto lg:mx-0 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative">
              <div className="relative rounded-lg overflow-hidden border border-border shadow-lg" style={{
              backgroundColor: "var(--background)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_analytics_dashboard_interface.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_analytics_dashboard_interface.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_analytics_dashboard_interface.webp-wvc-sizes" alt="Modern data analytics dashboard interface showing business intelligence metrics" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[3/4] lg:aspect-[3/5]" />
              </div>
              <p className="mt-4 font-mono text-xs uppercase tracking-[0.14em] text-muted-foreground italic">
                 infinix intelligence dashboard
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}